var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExhibitionSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.25c3.938 0 7.25 3.402 7.25 7.75s-3.312 7.75-7.25 7.75S1.25 13.348 1.25 9 4.562 1.25 8.5 1.25z",
    stroke: "#2672E3",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.116 21.884a1.25 1.25 0 001.768-1.768L20 21l-.884.884zM14 15l-.884.884 6 6L20 21l.884-.884-6-6L14 15z",
    fill: "#2672E3"
  })));
}

export default SvgExhibitionSearchIcon;